module.exports = __webpack_public_path__ + "fonts/iconfont.6b2e01a0.woff2";